// src/screens/NotificationSettings.tsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Bell } from "lucide-react";
import NotificationPreferencesPanel from "../components/NotificationPreferencesPanel";
import i18n from "../i18n";

function useI18nSafe() {
  const [lng, setLng] = useState((i18n.resolvedLanguage || i18n.language || "fr").toLowerCase());
  useEffect(() => {
    const onChange = (l: string) => setLng(l.toLowerCase());
    i18n.on("languageChanged", onChange);
    return () => i18n.off("languageChanged", onChange);
  }, []);
  const t = (key: string, options?: Record<string, unknown>): string =>
    options != null ? String((i18n.t as any)(key, options)) : String((i18n.t as any)(key));
  return { t, lng };
}

export default function NotificationSettings() {
  const { t } = useI18nSafe();

  return (
    <div className="max-w-2xl mx-auto px-4 py-6">
      <div className="flex items-center gap-3 mb-6">
        <Link
          to="/profile"
          className="inline-flex items-center justify-center rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-800"
          aria-label={t("notifications:back")}
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <h1 className="text-xl font-semibold flex items-center gap-2">
          <Bell className="w-5 h-5 text-orange-600" />
          {t("notifications:title")}
        </h1>
      </div>

      <NotificationPreferencesPanel />
    </div>
  );
}
